//import selectn          from 'selectn'
import getSportFromRoot  from './getSportFromRoot'
import qs                from 'query-string'

export default function getRequestParams( edition = {}, routerParams = {}, location = {} ) {

  const query         = location.query || qs.parse(location.search) || {}
  const params        = routerParams.params || {}
  const currRoot      = params.sport || edition.defaultSport /* the variable is called sport but it could be a league */
  const actualSport   = getSportFromRoot( currRoot ) || currRoot
  const pageType      = params.pageType || ''
  const slug          = params.slug || query.slug || ''
  const actualLeague  = params.league || query.league || query.leagueId || ''
  const actualGameId  = params.gameId || query.gameId || ''
  const actualSeason  = params.season || query.season || ''
  let actualTeam      =  ''

  if(pageType !== 'team') {
    actualTeam = params.team || query.team || ''
  }else{
    actualTeam = params.teamId || query.id || ''
  }

  let newParams = {
    sport : actualSport,
    root  : currRoot,
    slug  : slug
  }

  if ( actualGameId ) {
    newParams.gameId = actualGameId
  }

  if ( actualTeam ) {
    newParams.team = actualTeam
  }

  if ( actualLeague ) {
    newParams.league = actualLeague
  }

  if ( actualSeason ) {
    newParams.season = actualSeason
  }

  /* get default league if we need to hardcode one */

  /* pagetype can be modified here on a lang/location basis i.e. for es/ar we can take `resultados` and convert to `results`  */

  Object.assign( params, newParams  )

  return params

}



/** WEBPACK FOOTER **
 ** ../app/lib/utils/getRequestParams.js
 **/